import { isMessageV2DTO } from 'support/helpers/transactions/transactions';
import { PartnerDTO, TransactionOriginApp } from 'support/types';

import { DocumentDTO } from '../types';
import { RelatedMessages } from './RelatedMessages/RelatedMessages';
import { WebEDIDocumentProperties } from './WebEDIDocumentProperties/WebEDIDocumentProperties';

type OverviewTabProps = {
  document: DocumentDTO | undefined;
  documentOriginApp: TransactionOriginApp;
  relatedTransactions: Array<DocumentDTO> | undefined;
  currentPartner: PartnerDTO | undefined;
  isSenderEnvelope?: boolean;
  onViewPDF?: (url: string, filename: string) => void;
};

export const OverviewTab = ({
  document,
  currentPartner,
  relatedTransactions,
  isSenderEnvelope,
  documentOriginApp,
  onViewPDF,
}: OverviewTabProps) => {
  const isMessage = document && isMessageV2DTO(document);
  const senderPartner = isSenderEnvelope ? currentPartner : isMessage ? document.sender_partner : undefined;
  const receiverPartner = isSenderEnvelope ? null : isMessage ? document.receiver_partner : null;
  const otherPartner = currentPartner && senderPartner?.id === currentPartner?.id ? receiverPartner : senderPartner;

  return (
    <>
      <WebEDIDocumentProperties
        partner={otherPartner}
        document={document}
        documentOriginApp={documentOriginApp}
        currentPartner={currentPartner}
        onViewPDF={onViewPDF}
      />
      <RelatedMessages
        activeMessageId={document?.id}
        currentPartner={currentPartner}
        relatedMessages={relatedTransactions}
      />
    </>
  );
};
